// extracted by mini-css-extract-plugin
module.exports = {"pageCountDown":"PageCountDown_pageCountDown__DEKgJ"};